import { createSlice } from "@reduxjs/toolkit";
import {
  extraReducers,
  initialState,
  reducers,
} from "./reducers/profileAuthorisationStatusReducers";

export const ProfileAuthStatusSlice = createSlice({
  name: "profileAuthStatus",
  initialState,
  reducers,
  extraReducers,
});

export default ProfileAuthStatusSlice.reducer;
